<form class="w-100 h-100 form" [formGroup]="dataForm">
  <h4 class="text-center">Detalle de Solicitud</h4>
  <button class="btn-close" (click)="onNoClick()"></button>
  <!-- <h4 class="text-center" style="margin-top: 15px;">Afiliado</h4> -->
  <div class="row mx-0 mt-3 pt-0 pb-0 w-100">
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Primer Nombre</mat-label>
          <input matInput placeholder="Primer Nombre" formControlName="name" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Segundo Nombre</mat-label>
          <input matInput placeholder="Segundo Nombre" formControlName="secondname" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Apellido Paterno</mat-label>
          <input matInput placeholder="Apellido Paterno" formControlName="lastname" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Apellido Materno</mat-label>
          <input matInput placeholder="Apellido Materno" formControlName="secondlastname" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Documento</mat-label>
          <input matInput placeholder="Documento" formControlName="document" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Fecha de nacimiento</mat-label>
          <input matInput placeholder="Fecha de nacimiento" formControlName="birthday" readonly>
        </mat-form-field>
      </div>
    </div>
  </div>
  <h4 class="text-center" style="margin-top: 15px;">Declarante</h4>
  <div class="row mx-0 mt-3 pt-0 pb-0 w-100">
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Primer Nombre</mat-label>
          <input matInput placeholder="Primer Nombre" formControlName="nameDecla" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Segundo Nombre</mat-label>
          <input matInput placeholder="Segundo Nombre" formControlName="secondnameDecla" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Apellido Paterno</mat-label>
          <input matInput placeholder="Apellido Paterno" formControlName="lastnameDecla" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Apellido Materno</mat-label>
          <input matInput placeholder="Apellido Materno" formControlName="secondlastnameDecla" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Documento</mat-label>
          <input matInput placeholder="Documento" formControlName="documentDecla" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Fecha de nacimiento</mat-label>
          <input matInput placeholder="Fecha de nacimiento" formControlName="birthdayDecla" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Télefono</mat-label>
          <input matInput placeholder="Télefono" formControlName="phoneDecla" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Correo Electrónico</mat-label>
          <input matInput placeholder="Correo Electrónico" formControlName="emailDecla" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Relación con el afiliado</mat-label>
          <input matInput placeholder="Relación con el afiliado" formControlName="affiliaterelationship" readonly>
        </mat-form-field>
      </div>
    </div>
  </div>
  <h4 class="text-center" style="margin-top: 15px;" *ngIf="['method-pay'].includes(typeView)">Banco</h4>
  <div class="row mx-0 mt-3 pt-0 pb-0 w-100">
    <div class="col-3" *ngIf="['method-pay'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Número de poliza</mat-label>
          <input matInput placeholder="Número de poliza" formControlName="numberPolicy" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3" *ngIf="['method-pay'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Nombre del banco</mat-label>
          <input matInput placeholder="Nombre del banco" formControlName="nameBank" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3" *ngIf="['method-pay'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Tipo de cuenta</mat-label>
          <input matInput placeholder="Tipo de cuenta" formControlName="typeCta" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3" *ngIf="['method-pay'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Número de cuenta</mat-label>
          <input matInput placeholder="Número de cuenta" formControlName="numberCta" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3" *ngIf="['method-pay'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Número de cuenta interbancaria (CCI)</mat-label>
          <input matInput placeholder="Número de cuenta interbancaria (CCI)" formControlName="numberCtaCCI" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3" *ngIf="['method-pay'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Moneda</mat-label>
          <input matInput placeholder="Moneda" formControlName="currency" readonly>
        </mat-form-field>
      </div>
    </div>
  </div>
  <h4 class="text-center" style="margin-top: 15px;"
    *ngIf="['register-request','declaration-studies'].includes(typeView)">Beneficiario</h4>
  <div class="row mx-0 mt-3 pt-0 pb-0 w-100">
    <div class="col-3" *ngIf="['register-request','declaration-studies'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Primer Nombre Beneficiario</mat-label>
          <input matInput placeholder="Primer Nombre Beneficiario" formControlName="nameBenef" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3" *ngIf="['register-request','declaration-studies'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Segundo Nombre Beneficiario</mat-label>
          <input matInput placeholder="Segundo Nombre Beneficiario" formControlName="secondnameBenef" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3" *ngIf="['register-request','declaration-studies'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Apellido Paterno Beneficiario</mat-label>
          <input matInput placeholder="Apellido Paterno Beneficiario" formControlName="lastnameBenef" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3" *ngIf="['register-request','declaration-studies'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Apellido Materno Beneficiario</mat-label>
          <input matInput placeholder="Apellido Materno Beneficiario" formControlName="secondlastnameBenef" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3" *ngIf="['register-request'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Tipo de cuenta Beneficiario</mat-label>
          <input matInput placeholder="Tipo de cuenta Beneficiario" formControlName="typeCtaBenef" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3" *ngIf="['register-request'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Fecha de nacimiento Beneficiario</mat-label>
          <input matInput placeholder="Fecha de nacimiento Beneficiario" formControlName="birthdayBenef" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3" *ngIf="['register-request'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Dirección del Beneficiario</mat-label>
          <input matInput placeholder="Dirección del Beneficiario" formControlName="address" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3" *ngIf="['register-request'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Tipo de pensión de sobrevivencia</mat-label>
          <input matInput placeholder="Tipo de pensión de sobrevivencia" formControlName="typePension" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3" *ngIf="['register-request'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Sexo del Beneficiario</mat-label>
          <input matInput placeholder="Sexo del Beneficiario" formControlName="gender" readonly>
        </mat-form-field>
      </div>
    </div>
    <div class="col-3" *ngIf="['register-request'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Invalido Beneficiario</mat-label>
          <input matInput placeholder="Invalido Beneficiario" formControlName="invalidBeneficiary" readonly>
        </mat-form-field>
      </div>
    </div>
    <!-- <div class="col-3" *ngIf="['declaration-studies'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Tipo Documento Beneficiario</mat-label>
          <input matInput placeholder="Documento" formControlName="documentBenef" readonly>
        </mat-form-field>
      </div>
    </div> -->
    <div class="col-3" *ngIf="['declaration-studies'].includes(typeView)">
      <div>
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Documento Beneficiario</mat-label>
          <input matInput placeholder="Documento" formControlName="nroDocBenef" readonly>
        </mat-form-field>
      </div>
    </div>
  </div>
  <h4 class="text-center mt-2 mb-3">Documentos</h4>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="download">
        <th class="code" mat-header-cell *matHeaderCellDef>Descargar</th>
        <td class="code" mat-cell *matCellDef="let element">
          <mat-icon style="cursor: pointer;" (click)="downloadFile(element?.url)" matListIcon>download</mat-icon>
        </td>
      </ng-container>
      <ng-container matColumnDef="file">
        <th class="code" mat-header-cell *matHeaderCellDef>Archivo</th>
        <td class="code" mat-cell *matCellDef="let element">
          <p matLine>
            <span class="demo-2"> {{element?.file}} </span>
          </p>
        </td>
      </ng-container>
      <ng-container matColumnDef="dateRegister">
        <th class="code" mat-header-cell *matHeaderCellDef>Fecha</th>
        <td class="code" mat-cell *matCellDef="let element"> 
          <p matLine>
            <span class="demo-2"> {{element?.dateRegister}} </span>
          </p>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator #paginator [length]="allRegister" [pageIndex]="0" [pageSize]="pageSize" (page)="onPageFired($event)">
      >
    </mat-paginator>
  </div>

  <h4 class="text-center mt-4 mb-3" style="margin-top: 15px;">Historial</h4>
  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSourceHistory">
      <ng-container matColumnDef="status">
        <th class="code" mat-header-cell *matHeaderCellDef>Estado</th>
        <td class="code" mat-cell *matCellDef="let element"> {{element?.status}} </td>
      </ng-container>
      <ng-container matColumnDef="comment">
        <th class="code" mat-header-cell *matHeaderCellDef>Comentario</th>
        <td class="code" mat-cell *matCellDef="let element"> {{element?.comment}} </td>
      </ng-container>
      <ng-container matColumnDef="statusDate">
        <th class="code" mat-header-cell *matHeaderCellDef>Fecha</th>
        <td class="code" mat-cell *matCellDef="let element"> {{element.statusDate}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsHistory"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsHistory;"></tr>
    </table>
    <mat-paginator #paginator [length]="allRegisterHistory" [pageIndex]="0" [pageSize]="pageSize" (page)="onPageFiredHistory($event)">
      >
    </mat-paginator>
  </div>

  <div class="bottom-button">
    <button class="vs-btn-blue" (click)="onNoClick()">
      Cerrar
    </button>
  </div>
</form>